import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { combiner, featureKey } from './combiner';

import { RoadTypesEffects } from './roadTypes/effects';
import { RoadTypesService } from './roadTypes/service';
import { RoadTypeEffects } from './roadType/effects';
import { RoadTypeService } from './roadType/service';
import { TownsEffects } from './towns/effects';
import { TownsService } from './towns/service';
import { TownEffects } from './town/effects';
import { TownService } from './town/service';
import { GendersEffects } from './genders/effects';
import { GendersService } from './genders/service';
import { GenderEffects } from './gender/effects';
import { GenderService } from './gender/service';
import { HomeTypesEffects } from './homeTypes/effects';
import { HomeTypesService } from './homeTypes/service';
import { HomeTypeEffects } from './homeType/effects';
import { HomeTypeService } from './homeType/service';
import { FloorNumbersEffects } from './floorNumbers/effects';
import { FloorNumbersService } from './floorNumbers/service';
import { FloorNumberEffects } from './floorNumber/effects';
import { FloorNumberService } from './floorNumber/service';
import { AlarmTypesEffects } from './alarmTypes/effects';
import { AlarmTypesService } from './alarmTypes/service';
import { AlarmTypeEffects } from './alarmType/effects';
import { AlarmTypeService } from './alarmType/service';
import { HomeRegimesEffects } from './homeRegimes/effects';
import { HomeRegimesService } from './homeRegimes/service';
import { HomeRegimeEffects } from './homeRegime/effects';
import { HomeRegimeService } from './homeRegime/service';
import { HomeUsesEffects } from './homeUses/effects';
import { HomeUsesService } from './homeUses/service';
import { HomeUseEffects } from './homeUse/effects';
import { HomeUseService } from './homeUse/service';
import { FinancialEntityNamesEffects } from './financialEntityNames/effects';
import { FinancialEntityNamesService } from './financialEntityNames/service';
import { FinancialEntityNameEffects } from './financialEntityName/effects';
import { FinancialEntityNameService } from './financialEntityName/service';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      RoadTypesEffects,
      RoadTypeEffects,
      TownsEffects,
      TownEffects,
      GendersEffects,
      GenderEffects,
      HomeTypesEffects,
      HomeTypeEffects,
      FloorNumbersEffects,
      FloorNumberEffects,
      AlarmTypesEffects,
      AlarmTypeEffects,
      HomeRegimesEffects,
      HomeRegimeEffects,
      HomeUsesEffects,
      HomeUseEffects,
      FinancialEntityNamesEffects,
      FinancialEntityNameEffects,
    ]),
    StoreModule.forFeature(featureKey, combiner),
  ],
  providers: [
    RoadTypesService,
    RoadTypeService,
    TownsService,
    TownService,
    GendersService,
    GenderService,
    HomeTypesService,
    HomeTypeService,
    FloorNumbersService,
    FloorNumberService,
    AlarmTypesService,
    AlarmTypeService,
    HomeRegimesService,
    HomeRegimeService,
    HomeUsesService,
    HomeUseService,
    FinancialEntityNamesService,
    FinancialEntityNameService,
  ],
})
export class CatalogStoreModule {}
